import React, { useState } from "react";
import "./FAQ.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Navbar from "./Navbar";
import Footer from "./Footer";

const faqs = [
    {
        question: "What is Medby Academy?",
        answer:
            "Medby Academy is an online medical education platform that offers certified professional healthcare courses designed for students, medical professionals, and practitioners seeking career advancement and skill development.",
    },
    {
        question: "Are the courses recognized or certified?",
        answer:
            "Yes, all Medby Academy courses come with certification upon successful completion. Certificates are issued by Medby Academy and affiliated educational or healthcare institutions.",
    },
    {
        question: "Who can enroll in Medby Academy courses?",
        answer:
            "Our courses are open to medical students, healthcare professionals (nurses, technicians, paramedics, doctors), and individuals seeking to enter the healthcare field.",
    },
    {
        question: "Are classes conducted online or offline?",
        answer:
            "All programs are 100% online, allowing you to study anytime and anywhere at your convenience.",
    },
    {
        question: "What types of courses are available?",
        answer:
            "Medby Academy offers short-term certificate and professional development courses in areas such as Ultrasound Technician, Family Medicine, Nursing Care, Physician Assistant, and Emergency & Critical Care.",
    },
    {
        question: "How long do the courses take to complete?",
        answer:
            "Course duration varies — most programs range from 3 months to 12 months, depending on the course type and learning requirements.",
    },
    {
        question: "What are the eligibility criteria?",
        answer:
            "Eligibility depends on the course. Generally, certificate courses require 10+2 or equivalent, while advanced programs require a diploma or degree in a relevant healthcare field.",
    },
    {
        question: "How can I enroll in a course?",
        answer:
            "You can enroll directly through our website www.medbyacademy.com by filling out the registration form and completing the payment process.",
    },
    {
        question: "Is there any support available during the course?",
        answer:
            "Yes, Medby Academy provides dedicated academic and technical support throughout your course. You’ll also get guidance from experienced instructors.",
    },
    {
        question: "Can I learn at my own pace?",
        answer:
            "Absolutely! All online lessons are designed for self-paced learning, so you can study according to your schedule.",
    },
    {
        question: "Are there any live sessions or webinars?",
        answer:
            "Yes, many classes include live interactive sessions and expert webinars to enhance your learning experience.",
    },
    {
        question: "What happens after completing the course?",
        answer:
            "You will receive a digital certificate of completion and hardcopy through courier. Many students use it to enhance their resumes, qualify for better job opportunities, or pursue advanced studies.",
    },
    {
        question: "How do I get my certificate?",
        answer:
            "Certificates are emailed to students or made available in their student dashboard once they complete all modules and assessments.",
    },
    {
        question: "How do I contact Medby Academy for help?",
        answer:
            "You can reach us through: Email: support@medbyacademy.com or Website: www.medbyacademy.com",
    },
    {
        question: "Why should I choose Medby Academy?",
        answer:
            "100% online & flexible learning, Industry-recognized certification, Affordable and accessible education, Expert faculty & mentorship, Career-oriented medical courses.",
    },
];

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <>
            <Navbar />
            <section className="faq-section">
                <div className="faq-container">
                    <h2 className="faq-title">Frequently Asked Questions (FAQ)</h2>
                    <p className="faq-subtitle">
                        Find answers to the most common questions about Medby Academy.
                    </p>

                    <div className="faq-list">
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className={`faq-item ${activeIndex === index ? "active" : ""}`}
                                onClick={() => toggleFAQ(index)}
                            >
                                <div className="faq-question">
                                    <h3>{faq.question}</h3>
                                    {activeIndex === index ? (
                                        <FaChevronUp className="icon" />
                                    ) : (
                                        <FaChevronDown className="icon" />
                                    )}
                                </div>
                                <div className="faq-answer">
                                    <p>{faq.answer}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer/>
        </>

    );
};

export default FAQ;
